import styled from 'styled-components';
import LandingWrapper from '../LandingWrapper/LandingWrapper';
import Triangle from '../Triangle/Triangle';
import { Paragraph } from '../Paragraph/Paragraph';
import ShieldIcon from './assets/ShieldImg.png';
import AsteriskIcon from './assets/AsteriskImg.png';
import SkiIcon from './assets/SkiImg.png';
import { Title } from '../Title/Title';

const Downloads = () => {
  const title = `It's easy, but we made it even easier for you.`;
  const paragraph = `Check out all the features of our insurance in details.`;

  const items = [
    {
      image: ShieldIcon,
      title: 'COVERAGE AND LIMITS',
      text: 'Summary of benefits of the insurance',
      link: 'https://main.oncampusabroad.com/media/documents/OnCampusAbroad_Table-of-Contents.pdf',
      id: 'download_OnCampusAbroad_Table-of-Contents.pdf'
    },
    {
      image: SkiIcon,
      title: 'HOLIDAY & SPORTS PACKS',
      text: 'Know all the details of our extension packs',
      link: 'https://main.oncampusabroad.com/media/documents/OnCampus_Extension-Packages_conditions.pdf',
      center: 'center',
      id: 'download_OnCampus_Extension-Packages_conditions.pdf'
    },
    {
      image: AsteriskIcon,
      title: 'TERMS & CONDITIONS',
      text: 'All the detailed information about the OnCampus Abroad Insurance',
      link: 'https://main.oncampusabroad.com/media/documents/TermsConditions.pdf',
      id: 'download_Insurance_Conditions_OnCampusAbroad.pdf?_gl=1*1gofet6*_gcl_au*MjExMjAxMTg2Mi4xNzMyNjM0Njk1*_ga*MTExMDkzODEzOS4xNzMyNjM0Njk0*_ga_CGYK4H4DMH*MTczMzIyMjgyNC42LjAuMTczMzIyMjgzMy41MS4wLjEzMTU4NTIyNjA'
    }
  ];

  return (
    <>
      <Background>
        <LandingWrapper>
          <Content>
            <Title text={title} color='light' />
            <Container>
              {items.map((item, index) => (
                <Card key={index} bordered={index === 1}>
                  <Image src={item.image} alt={item.title} />
                  <TitleCard text={item.title} />
                  <Description text={item.text} />
                  <Link href={item.link} target='_blank' rel='noopener noreferrer' id={item.id}>
                    Download
                  </Link>
                </Card>
              ))}
            </Container>
            <Paragraph text={paragraph} color='light' />
          </Content>
        </LandingWrapper>
        <Triangle color='white' position='right' orientation='bottom' />
      </Background>
    </>
  );
};

export default Downloads;

const Background = styled.div`
  width: 100%;
  background-color: white;
  position: relative;
  padding: 90px 0 45px 0;

  @media (min-width: 768px) {
    padding: 111px 0;
  }

  @media (min-width: 1024px) {
    padding: 120px 0 220px 0;
  }
`;

const Content = styled.div`
  background-color: #283288;
  border-radius: 20px;
  padding: 38px 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  gap: 38px;
  max-width: 1248px;

  @media (min-width: 768px) {
    gap: 78px;
    border-radius: 47px;
    padding: 96px 64px;
  }

  @media (min-width: 1024px) {
    padding: 48px 42px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 38px;

  @media (min-width: 768px) {
    gap: 78px;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    gap: 0;
  }
`;

const Card = styled.div<{ bordered?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 768px) {
    max-width: 420px;
    padding: 0 27px;
  }

  @media (min-width: 1024px) {
    ${({ bordered }) =>
      bordered &&
      `
      max-width: 456px;
    `}

    ${({ bordered }) =>
      bordered &&
      `
      border-left: 1px solid #fff6ef;
      border-right: 1px solid #fff6ef;
    `}
  }
`;

const Image = styled.img`
  margin-bottom: 15px;
  width: 64px;
  height: 64px;

  @media (min-width: 768px) {
    margin-bottom: 34px;
    width: 120px;
    height: 120px;
  }
`;

const TitleCard = styled(Paragraph)`
  text-transform: uppercase;
  color: #fff6ef !important;
  font-weight: 700;
  font-size: 15px;
  line-height: normal;
  margin: 0 0 8px 0;

  @media (min-width: 768px) {
    font-size: 25px;
  }
`;

const Description = styled(Paragraph)`
  color: #fff6ef !important;
  font-size: 15px;
  line-height: normal;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 25px;
  }
`;

const Link = styled.a`
  color: #fff6ef !important;
  font-size: 15px;
  margin-top: 15px;

  @media (min-width: 768px) {
    font-size: 25px;
    margin-top: 26px;
  }
`;
